
import Vue from 'vue'
import { FormWizard, TabContent, WizardStep } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { ValidationObserver, ValidationProvider, extend, localize } from 'vee-validate';
import { required, email, length, regex } from 'vee-validate/dist/rules';
import i18n from '../locales'
import * as rules from "vee-validate/dist/rules";
import axios from 'axios'
const ThemifyIcon = require("vue-themify-icons");
const en = require('vee-validate/dist/locale/en.json');
const ja = require('vee-validate/dist/locale/ja.json');
const ko = require('vee-validate/dist/locale/ko.json');
const zh_CN = require('vee-validate/dist/locale/zh_CN.json');
const zh_TW = require('vee-validate/dist/locale/zh_TW.json');

extend('customChecklist', (value, { } = {}) => {
  const reqValues = ['1', '2', '3', '5'];
  return value.length === 5 || reqValues.every((reqVal: string) => value.includes(reqVal));
});
extend('required', required)
extend('email', email)
extend('length', length)
extend('regex', regex)
localize({en, ja, ko, zh_CN, zh_TW})

export default Vue.extend({
  i18n: {
    messages: {
      en:{
        confirmSubmission: "Confirm submission", 
        errorSubmission: 'An unknown error has occurred. Please check the form and try again. Email contact@lowiro.com if this error persists.',
        errors: {
          agreeRules: "Please agree to the rules", 
          allUpload: "Please check all the upload content"
        }, 
        submit: "Submit", 
        back: "Back",
        next: "Next",
        finish: 'Finish',
        backToArcaea: "Back to Arcaea Top", 
        submissionBanner: "Submission deadline: 2020/09/30", 
        term: "I have read the {0}", 
        tos: "rules and submission requirements",
        thankYou: {
          title: "Arcaea Song Contest - 3rd Movement", 
          subtitle: 'Imagining After',
          context1: "Submission Complete.", 
          context2: "You will receive confirmation by e-mail within 72 hours."
        }, 
        form: {
          title: "Arcaea Song Contest - 3rd Movement", 
          subtitle: 'Imagining After',
          nav: {
            welcome: "Welcome", 
            contact: "Contact", 
            submission: "Submission", 
            additionalInfo: "Additional Info"
          }, 
          content: {
            1: {
              email: "E-mail", 
              subtitle1: "This email address will only be used to send submission confirmations and winning notifications.", 
              subtitle2: "Information submitted will be stored securely and only used for the purposes of judging and notifying the winners of this contest."
            },
            2: {
              subtitle: {
                songInfo: "Song Info", 
                songInfoContext: "Song and Artist name to be displayed in-game", 
                artistInfo: "Artist Info", 
                uploadFile: "Upload File"
              }, 
              songTitle: "Song Title", 
              songTitlePlaceholder: "Song Title",
              songArtist: "Song Artist", 
              songArtistPlaceholder: "Song Artist",
              artistName: "Artist Name", 
              artistNamePlaceholder: "Artist Name", 
              socialMedia: "Social Media", 
              socialMediaPlaceholder: "Twitter / SoundCloud / YouTube / etc", 
              addAnotherArtist: "Add another artist", 
              removeLastArtist: "Remove last artist", 
              uploadFileLink: "Upload File Link", 
              uploadFileLinkPlaceholder: "Dropbox / Google Drive / Firestorage / etc", 
              uploadPassword: "Upload Password", 
              uploadPasswordPlaceholder: "Optional, password to access files", 
              uploadContent: "Upload Content", 
              uploadContentCheck: {
                1: "One mastered .wav file and one premaster .wav file (48kHz 24-bit)",
                2: "One mastered .mp3 file (320kbps)",
                3: ".txt file with BPM and Metre information",
                4: "(optional) .txt file with lyrics",
                5: "File names which follow this format:", 
                artistName: "Artist name", 
                songTitle: "Song title"
              },
              linkPassConfirm: "Please ensure that file links and passwords are correct before sending. Entries that cannot be accessed will not be judged."
            },
            3: {
              theme: "Theme", 
              themeContext1: "Optional. The theme / setting / idea the song is based on. Max 100 characters.", 
              themeContext2: "This entry is not compulsory but may help your song be selected."
            }
          },
        },
        thankYouFinished: "Thank you for your participation in the Arcaea Song Contest - 3rd Movement. Submissions are now closed.<br/>The winners will be contacted at a later date.",
      },
      ja: {
        confirmSubmission: "提出を確認する", 
        errorSubmission: "原因不明の不具合が発生しました。大変お手数ですが、再度やり直して下さい。<br/>もしも不具合が継続する場合は、contact@lowiro.comまでご連絡ください。",
        errors: {
          agreeRules: "要項を読み、了承して下さい", 
          allUpload: "提出するファイルとファイル名が正しいことを確認してください"
        }, 
        submit: "提出する", 
        back: "戻る",
        next: '次へ',
        finish: '完了する',
        backToArcaea: "Arcaea公式サイトに戻る", 
        submissionBanner: "最終締切は水曜日2020/09/30です。余裕を持ってお願いします。", 
        term: "コンテストの{0}を理解の上、遵守します。", 
        tos: "ルールと、提出要項", 
        
        thankYou: {
          title: "Arcaea楽曲コンテスト",
          subtitle: '第3回 『Imagining After』',
          context1: "ご提出ありがとうございます。おつかれさまでした。", 
          context2: "受け付け証明のメールが72時間以内に送信されますので、メールをご確認下さい。"
        }, 
        form: {
          title: "Arcaea楽曲コンテスト", 
          subtitle: '第3回 『Imagining After』',
          nav: {
            welcome: "TOP", 
            contact: "連絡先入力", 
            submission: "提出ページ", 
            additionalInfo: "追記・備考など"
          }, 
          content: {
            1: {
              email: "メールアドレス", 
              subtitle1: "今回ご記入のメールアドレスは、安全に保管され、", 
              subtitle2: "ご提出の受け取り証明のメールと、入賞時のお知らせの際にのみ使用されます。それ以外の用途では使用いたしません。"
            },
            2: {
              subtitle: {
                songInfo: "楽曲情報", 
                songInfoContext: "ゲームで表示される曲名とアーティスト名義", 
                artistInfo: "参加者・共作者情報", 
                uploadFile: "提出ファイル"
              }, songTitle: "楽曲名", 
              songTitlePlaceholder: "楽曲名", 
              songArtist: "アーティスト名", 
              songArtistPlaceholder: "アーティスト名", 
              artistName: "アーティスト名義", 
              artistNamePlaceholder: "アーティスト名義", 
              socialMedia: "SNS IDなど", 
              socialMediaPlaceholder: "Twitter / SoundCloud / YouTubeなど", 
              addAnotherArtist: "別のアーティストを追加する", 
              removeLastArtist: "最後に追加したアーティストを取り除く", 
              uploadFileLink: "提出ファイルのリンク", 
              uploadFileLinkPlaceholder: "Dropbox / Google Drive / Firestorageなど", 
              uploadPassword: "アップロード用パスワード", 
              uploadPasswordPlaceholder: "ファイルにパスワードを設定した場合、記入してください", 
              uploadContent: "以下のファイルを含めました", 
              uploadContentCheck: {
                1: "48kHz 24-bit WAVファイルを2つ(マスタリング済みと非マスター2mix音源)",
                2: "320kbps MP3ファイルを1つ(マスタリング済み)",
                3: "BPMや拍子変更などの情報を記述したテキストファイル",
                4: "(任意)歌詞を書いたテキストファイル",
                5: "提出するファイル名は以下のフォーマットでお願いします:", 
                artistName: "アーティスト名", 
                songTitle: "曲名"
              }, 
              linkPassConfirm: "アクセスできないファイルは失格となります。リンクとパスワードはご提出の前にしっかりご確認ください。"
            },
            3: {
              theme: "テーマ", 
              themeContext1: "(任意) 楽曲の元になったテーマ、設定、アイディアなどを100字以内で書いてください。", 
              themeContext2: "本項目は必須ではありませんが、審査項目の1つです。"
            }
          },
        },
        thankYouFinished: "Arcaea楽曲コンテスト 第三回『Imagining After』へのご参加、ありがとうございます。 提出はすでに締め切らせていただきました。<br/>入賞者は後日、弊社より連絡差し上げます。今しばらくお待ち下さい。",
      }
    }
  },
  metaInfo() {
    const vm = this as any;
    return {
      title: `${this.$t('form.title').toString()} ${vm.currentLang === 'EN' ? '|' : ''} ${this.$t('form.subtitle').toString()}`,
    }
  },
  data() {
    return {
      submission: {
        isAgreeRules: false,
        isAgreeInfo: false,
        archiveContents: [],
        email: '',
        artists: [{
          name: '',
          sns: ''
        }
        ],
        uploadLink: '',
        uploadPassword: '',
        songTitle: '',
        songArtist: '',
        theme: '',
      },
      termsOfServiceUrl: 'https://twitter.com/arcaea_en/status/1577810875469238272/photo/2',
      currentLang: 'EN',
      flagClass: {'flag-icon-us': true } as any,
      isLoading: false,
      isSuccess: false,
      isErrorSubmit: false,
      errorAgreeRules: false,
      isOngoing: false,
      endTs: 1671091800000,
    }
  },
  components: {
    FormWizard, TabContent, WizardStep, ThemifyIcon, ValidationProvider, ValidationObserver
  },
  computed: {
    archiveContentOptions() {
      return [
        { text: this.$t('form.content.2.uploadContentCheck.1'), value: '1' },
        { text: this.$t('form.content.2.uploadContentCheck.2'), value: '2' },
        { text: this.$t('form.content.2.uploadContentCheck.3'), value: '3' },
        { text: this.$t('form.content.2.uploadContentCheck.4'), value: '4' },
        { text: this.$t('form.content.2.uploadContentCheck.5'), value: '5' },
      ]
    }
  },
  mounted(){
    const vm = this as any;
    const lang = window.navigator.languages || [window.navigator.language];
    if (lang[0] && lang[0].startsWith('ja')) {
      vm.setLang('jp')
    }
    const now = Date.now();
    vm.isOngoing = now < vm.endTs;
  },
  methods: {
    onComplete() {
      // alert('Yay. Done!');
      const vm = this as any;
      vm.$refs['modal-confirm'].show();
    },
    setLang(lang: string) {
      const vm = this as any;
      const langText = {
        us: 'EN',
        jp: 'JP'
      } as any
      const langValidate = {
        'us': 'en',
        'jp': 'ja'
      } as any
      vm.currentLang = langText[lang]
      vm.flagClass = {
        [`flag-icon-${lang}`]: true
      }
      localize(langValidate[lang])
      i18n.locale = langValidate[lang]
      vm.termsOfServiceUrl = require(`@/assets/rules_${langValidate[lang]}.png`)
    },
    getValidationState({ dirty, validated, valid = null }: any) {
      return dirty || validated ? valid : null;
    },
    handleValidation(isValid: boolean, tabIndex: number) {
      // console.log('Tab: '+tabIndex+ ' valid: '+isValid)
    },
    addArtist() {
      const vm = this as any;
      vm.submission.artists.push({
        name: '',
        sns: ''
      });
    },
    removeArtist(){
      const vm = this as any;
      vm.submission.artists.pop();
    },
    async doSubmit() {
      const vm = this as any;
      vm.isLoading = true;
      
      // await new Promise((resolve, reject) => {setTimeout(() => resolve(true), 1000)});
      
      const data = Object.assign({}, vm.submission);
      const artists = data.artists.map((artist: any, idx: number) => {
        data[`artist${idx}name`] = artist.name;
        data[`artist${idx}sns`] = artist.sns;
        return `${artist.name} (${artist.sns})`;
      });
      data.artists = artists.join(', ');
      
      try {
        const response = await axios.request({
          url: 'https://3upu94x4x3.execute-api.us-west-2.amazonaws.com/prod/song-contest-api',
          method: 'post',
          headers: {
            "Content-Type": "application/json",
          },
          data
        });
        if (response.data.statusCode !== 200) {
          throw [response.data.statusCode, response.data.body];
        };
        vm.isLoading = false;
        vm.isSuccess = true;
      } catch (e) {
        console.log(e);
        vm.isSuccess = false;
        vm.isErrorSubmit = true;
      } finally {
        vm.isLoading = false;
      }
    },
    validate(step: string) {
      return async () => {
        const vm = this as any;
        let val = true;
        switch (step) {
          case 'agreement':
            // return true;
            vm.errorAgreeRules = !vm.submission.isAgreeRules;
            return vm.submission.isAgreeRules
          case 'contact':
            // return true;
            return (await vm.$refs.email.validate()).valid;
          case 'submission':
            // return true;
            return (await vm.$refs.submissionObserver.validate());
          default:
            return true;
        }
      }
    }
  }
})
